import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { useToast } from '@/components/feedback/toast';
import { routes } from '@/config/routes';
import { useAuth } from '@/providers/auth-provider';
import type { Role } from '@/types';

export function RequireRole({ roles, pageName }: { roles: Role[]; pageName: string }) {
  const { user } = useAuth();
  const toast = useToast();
  const ok = user?.role ? roles.includes(user.role) : false;

  useEffect(() => {
    if (!ok) {
      toast.error({
        key: `access-denied-${pageName}`,
        title: `Access Denied. You do not have permission to access ${pageName}`,
      });
    }
  }, [ok, pageName, toast]);

  if (!ok) {
    return <Navigate to={routes.dashboard} replace />;
  }
  return <Outlet />;
}
